import type { MtCardItemAnimalData } from '@presentation/components';
import type { MouseEventHandler } from 'react';

export interface MtAnimalsBuyerPageProps {
  items: MtCardItemAnimalData[];
  onAddClick?: MouseEventHandler;
  loading?: boolean;
  showArchived: boolean;
  onToggleShowArchived: (value: boolean) => void;
}
